import {MakeQueryForEsFn} from "./search";

export const makeKnnQueryWithKeyword: MakeQueryForEsFn = (
    resultSize: number,
    searchTerm: string,
    dateFilters: any[] ,// Assuming dateFilters is an array of filter objects
    companyId: string,
    _searchAfter,
    embeddingModel
) => ({
    size: resultSize,
    _source: {
        excludes: [
            "full_text_embeddings",
            "full_text",
            "file",
            "pdf file path",
            "pdf",
        ],
    },
    knn: {
        field: "full_text_embeddings",
        query_vector_builder: {
            text_embedding: {
                model_id: embeddingModel,
                model_text: searchTerm,
            },
        },
        k: resultSize,
        num_candidates: resultSize * 20,
    },
    query: {
        bool: {
            should: [
                { term: { "companyIdTags.keyword": companyId }},
                { term: { isPublic: true }}
            ],
            minimum_should_match: 1
        }
    },
    ...(dateFilters.length > 0 && {
        filter: dateFilters, // Apply additional date filters if any
    }),
    from: 0,
});